/**
 * Feature Access Hook (Web)
 * Thin wrapper around shared hook — extracts tier from AuthContext.
 */

import { useAuth } from '@contexts/AuthContext';
import {
  type UseFeatureAccessResult,
  useFeatureAccess as useFeatureAccessShared,
} from '@parlay-picker/shared/hooks/useFeatureAccess';
import { isValidSubscriptionTier } from '@parlay-picker/shared/subscriptionTier';
import { useMemo } from 'react';

export type { UseFeatureAccessResult };

export function useFeatureAccess(): UseFeatureAccessResult {
  const { user } = useAuth();
  const tier = useMemo(
    () => (isValidSubscriptionTier(user?.role) ? user!.role : 'free'),
    [user?.role],
  );
  return useFeatureAccessShared({ tier });
}
